export default __webpack_public_path__ + "static/media/weather-small.78124623.jpg";